import { Vec2 } from 'planck-js'
import { assert } from '../../lib/assert-sidecar'
import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import { voyageMessageJettison } from './multi/voyageMessageJettison-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_crew } from './voyageCrew_crew-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  d.useSystemTimer += ds

  let useSystemTime = 0.5
  voyageCrew_crew.setProgress(obj, d.useSystemTimer / useSystemTime)

  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      let sysTarget = voyageTilemap.getSystemSafeByKey(
        ('' + tHere.text3).replace('ejectrol', 'ejector'),
      )
      let ejectionPoint = voyageTilemap.getSystemSafeByKey(
        ('' + tHere.text3).replace('ejectrol', 'ejp'),
      )
      if (sysTarget) {
        let targetCrew = voyageCrew.getAt(
          sysTarget,
          (c) =>
            c.type === EVoyageCrewType.Crew || c.type === EVoyageCrewType.Alien,
        )
        // if (targetCrew) {
        //   if (voyageWebsockets.getIsHost()) {
        //     voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
        //       crewId: targetCrew.id,
        //       byCrewId: 0,
        //       newHitpoints: 0,
        //       type: EVoyageCrewDamageType.Jettison,
        //     })
        //   }
        // }

        // // Testing!
        // let id = voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
        //   type: EVoyageCarryableType.Medpack,
        //   i: sysTarget.i,
        //   j: sysTarget.j,
        // })
        // let testCy = voyageCarryable.findById(id)
        // assert.notNil(testCy)
        // voyageCarryable.setAtTile(testCy, sysTarget)

        let x = sysTarget.x
        let y = sysTarget.y
        let dx = -1
        let dy = 0
        if (ejectionPoint) {
          x = ejectionPoint.x
          y = ejectionPoint.y
          let v = Vec2(
            ejectionPoint.x - sysTarget.x,
            ejectionPoint.y - sysTarget.y,
          )
          v.normalize()
          dx = v.x
          dy = v.y
        }

        if (sysTarget.items.length > 0) {
          l.forEach(sysTarget.items, (c) => {
            voyageMessageJettison.sendMessageAndImmediatelyExecute({
              carryableId: c.id,
              crewId: 0,
              x,
              y,
              dx,
              dy,
            })
          })
        }
      }
    }
  }
}
